// ----------- Config for Statistics View ---------------//

export const ARROW_SIZE = 8;

export const STROKEWIDTH = 2;

export const PASS_COLOR_SUCC = "MediumBlue";

export const PASS_COLOR_FAIL = "Red";

export const PASS_COLOR_ASSIST_SUCC = "Yellow";

export const PASS_COLOR_ASSIST_FAIL = "DarkGray";

export const SHOOT_COLOR_GOAL = "Yellow";

export const YELLOW_CARD = "Yellow";

export const RED_CARD = "Red";

export const SHOOT_COLOR_OFF_TARGET = "Red";

export const SHOOT_COLOR_BLOCKED = "DarkGray";

export const TAKE_ONS_COLOR_SUCC = "LawnGreen";

export const TAKE_ONS_COLOR_FAIL = "Orange";

export const TACKLES_COLOR_SUCC = "LawnGreen";

export const TACKLES_COLOR_FAIL = "Orange";

export const BLOCK_COLOR = "DarkGray";

export const FOULS_COLOR_COMMITTED = "black";

export const FOULS_COLOR_SUFFERED = "white";

export const COLOR_WIN = "LawnGreen";

export const COLOR_LOSE = "Orange";

export const INTERCEPTION_COLOR = "LawnGreen";

export const BALL_RECOVERY_COLOR = "LawnGreen";

// ----------- End for Statistics View ---------------//

// ----------- Config for speed setting ---------------//
export const IDLE_THRESHOLD = 0.5;

export const WALKING_THRESHOLD = 2;

export const RUNNING_THRESHOLD = 6;
// ----------- End for speed setting ---------------//
